<ion-content>
    <ion-datetime 
        #datetime 
        (ionChange)="changeStartDate($event)" 
        [value]="dateTimeValue"
        size="cover"
        presentation="date-time" 
        minuteValues="0,15,30,45">
    </ion-datetime>
</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button (click)="cancel()">
                {{ 'Cancel' | translate }}
            </ion-button>

            <ion-button (click)="confirm()">
                {{ 'Done' | translate }}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>